<template>
    <div>
        <div class="columns">
            <div class="column">
                <form-field
                    label="Type"
                    :error="error.type"
                >
                    <input-text
                        :disabled="!editableType"
                        v-model="form.type"
                        :error="error.type"
                    />
                </form-field>
            </div>
            <div class="column">
                <form-field
                    label="Fabrikant"
                    :error="error.manufacturer_name"
                >
                    <InputSelectSearch
                        :options="listManufacturers"
                        v-model="manufacturerName"
                        :disabled="!editableManufacturerName || isOtherManufacturerNameChecked"
                        :error="error.manufacturer_name"
                        id="id"
                        label="name"
                    />
                    <label><input type="checkbox" v-model="isOtherManufacturerNameChecked" @click="updateManufacturerName"> Øvrige</label>
                </form-field>
            </div>
        </div>

        <div class="columns">
            <div class="column">
                <form-field
                    label="Beskrivelse"
                    :error="error.description"
                >
                    <InputTextarea
                        v-model="form.description"
                        rows="2"
                        :disabled="!editableDescription"/>
                </form-field>
            </div>
        </div>

        <div class="columns">
            <div class="column">
                <form-field
                    label="Oprindelsesland"
                    :error="error.country_id"
                >
                    <InputSelectSearch
                        :options="listCountries"
                        v-model="countryId"
                        :disabled="!editableOrigin"
                        :error="error.country_id"
                        label="title"
                    />
                </form-field>

                <form-field
                    label="Serienummer"
                    :error="error.serial"
                >
                    <input-text
                        :disabled="!editableSerial"
                        v-model="form.serial"
                        :error="error.serial"
                    />
                </form-field>

                <form-field
                    label="Leveringsdato"
                    :error="error.deliver_at"
                >
                    <input-date
                        :disabled="!editableDeliver"
                        v-model="form.deliver_at"
                        :error="error.deliver_at"
                    />
                </form-field>

                <form-field
                    label="Vægt (i gram)"
                    :error="error.weight"
                >
                    <input-text
                        :disabled="!editableWeight"
                        v-model="form.weight"
                        :error="error.weight"
                    />
                </form-field>

                <form-field
                    label="Toldkode"
                    :error="error.customs_code"
                >
                    <input-text
                        :disabled="!editableCustomsCode"
                        v-model="form.customs_code"
                        :error="error.customs_code"
                    />
                </form-field>
            </div>
            <div class="column">
                <form-field
                    label="Pris"
                    :error="error.price"
                    inner-container-class="has-icons-right"
                >
                    <input-decimal
                        :disabled="!editablePrice"
                        v-model="price"
                        :error="error.price"
                    />
                    <span class="icon is-right">{{ currency }}</span>
                </form-field>

                <form-field
                    label="Antal"
                    inner-container-class="on-stock"
                    :error="error.count"
                    :help-text="getHelpTextForCount"
                >
                    <InputDecimal
                        :disabled="!editableCount"
                        v-model.number="form.count"
                        :error="error.count"
                    />
                </form-field>


                <form-field
                    label="Rabat"
                    :error="error.discount"
                    inner-container-class="has-icons-right"
                >
                    <input-decimal
                        :disabled="!editableDiscount"
                        v-model.number="form.discount"
                        :error="error.discount"
                    />
                    <span class="icon is-right">%</span>
                </form-field>

                <form-field
                    label="Total pris"
                >
                    <input-static
                        v-model="totalPrice"
                    />
                </form-field>

                <form-field
                    v-if="isGoods"
                    label="Uden fragt"
                >
                    <input-checkbox
                        :disabled="!editableShipping"
                        v-model="form.no_shipping"
                    />
                </form-field>
            </div>
        </div>
    </div>
</template>

<script>
import FormField from "../../../elements/form/FormField";
import InputDecimal from "../../../elements/form/InputDecimal";
import InputText from "../../../elements/form/InputText";
import InputDate from "../../../elements/form/InputDate";
import InputStatic from "../../../elements/form/InputStatic";
import InputCheckbox from "../../../elements/form/InputCheckbox";
import InputSelectSearch from "../../../elements/form/InputSelectSearch";
import {mapGetters, mapActions} from "vuex";
import InputTextarea from "../../../elements/form/InputTextarea";

export default {
    props: {
        isGoods: Boolean,
        totalPrice: [String, Number],
        error: [Object, Array],
        form: Object,
        currency: String,
        maxCount: Number,
        editableManufacturerName: { type: Boolean, default: true },
        editableType: { type: Boolean, default: true },
        editableDescription: { type: Boolean, default: true },
        editableCount: { type: Boolean, default: true },
        editableSerial: { type: Boolean, default: true },
        editableDeliver: { type: Boolean, default: true },
        editablePrice: { type: Boolean, default: true },
        editableOrigin: { type: Boolean, default: true },
        editableDiscount: { type: Boolean, default: true },
        editableShipping: { type: Boolean, default: true },
        editableWeight: { type: Boolean, default: true },
        editableCustomsCode: { type: Boolean, default: true },
    },
    data() {
        return {
            isOtherManufacturerNameChecked: false
        }
    },
    components: { InputTextarea, InputSelectSearch, InputCheckbox, InputStatic, InputDate, InputText, InputDecimal, FormField },
    computed: {
        ...mapGetters([
            'listCountries',
            'findCountry',
            'listManufacturers',
        ]),
        countryId: {
            get() {
                return this.findCountry(this.form.country_id);
            },
            set(value) {
                this.form.country_id = value ? value.id : null
            }
        },
        manufacturerName: {
            get() {
                return this.listManufacturers.find(x => x.name == this.form.manufacturer_name)?.name;
            },
            set(value) {
                this.form.manufacturer_name = value ? value.name : null
            }
        },
        price: {
            get() {
                if (this.form.price === 0 || this.form.price === null) {
                    return 0;
                }
                return (this.form.price / 100).toFixed(2)
            },
            set(price) {
                let parsedPrice = Number.parseFloat(price);
                if (isNaN(parsedPrice)) {
                    parsedPrice = 0;
                }
                this.$set(this.form, 'price', Math.round(parsedPrice * 100))
            }
        },
        getHelpTextForCount() {
            return this.maxCount !== null ? `På lager: <strong>${this.maxCount}</strong>` : undefined;
        }
    },
    methods: {
        ...mapActions([
            'loadManufacturer'
        ]),
        updateManufacturerName(e) {
            const name = 'NORDIC A/S';
            const manufacturer = this.listManufacturers.find(x => x.name == name);
            if (manufacturer) {
                this.isOtherManufacturerNameChecked = !this.isOtherManufacturerNameChecked;
                this.manufacturerName = this.isOtherManufacturerNameChecked ? manufacturer : null;
                return;
            }

            e.preventDefault();
            alert(name + ' A/S kunne ikke findes som fabrikant.');
            this.isOtherManufacturerNameChecked = false;
        },
    },
    created() {
        this.loadManufacturer();
        this.$store.dispatch('loadCountries', () => {
            // const dk = this.listCountries.find(country => country.code === 'DK');
            // this.form.country_id = dk ? dk.id : null
        });
    }
}
</script>
